module.exports = __webpack_public_path__ + "cancellara-dist/img/assistenza_header.14a729a9.jpg";